module.exports = __webpack_public_path__ + "assets/img/B1.b8d32f90.jpg";